<button [matTooltip]="this.UserService.enableFileExport()?'Export':'Export service is disabled' " [matTooltipShowDelay]="1000" class="exportBtn" 
(click)="isVisible = true" type="button">Export <i class="fa fa-download"
    aria-hidden="true"></i>
</button>
@if(this.UserService.enableFileExport()){
<p-dialog [(visible)]="isVisible" styleClass="exportCSVfileDialog" icon="pi pi-exclamation-triangle" id="exportCSVDialog"
 appendTo="body" showEffect="fade" (onHide)="onHide()" header="Export Viewer">
  <div class="col-lg-12 mg-t-15">
    <div class="col-lg-4"><label for="selectColumn">Select Column</label></div>    
      <p-multiSelect id="exportViewerDrpbyTypeMultiSelect" class="col-lg-8 nopadding topPadding" autofocus [options]="sortedGridColumns"
      appendTo="body" placeholder="Select Events" [(ngModel)]="selectedColumns"
      [style]="{ 'text-transform': 'capitalize','overflow':'visible','width':'65%','border-radius':'0px','padding':'2px !important'}">
      <ng-template let-filterCols pTemplate="item">
        <span [id]="filterCols.label" [matTooltip]="sortedGridColumns.value" [matTooltipShowDelay]="1000" matTooltipPosition="after">
          {{filterCols?.label}}</span>
      </ng-template>
    </p-multiSelect>
  </div>
  <div class="col-lg-12 float-right btnClassAlign">
    <p-button type="button"  matTooltip="Export Current page of selected columns" [matTooltipShowDelay]="1000" [disabled]="isExport1000RowsForSelectedCol" class="mg-t-5 col-mg-3 float-right"
     id="exportCurrentPage" label="Current page" (click)="exportSelectedColumn(false)">
    </p-button>
    <p-button type="button"  matTooltip="Export 20000 rows of selected columns" [matTooltipShowDelay]="1000" [disabled]="isExportMaxRowsForSelectedCol" class="mg-t-5 col-mg-3 mg-r-5 float-right"
     id="20000rows" label="20000 Rows" (click)="exportSelectedColumn(true)">
    </p-button>
  </div>
</p-dialog>
}
